import React from 'react';
import '../../styles/App.css';
import '../../styles/Table.css'
import {api} from "../../api/v1/api";

/**
 * Class used for rendering handling the selection of hardware dependencies for NAOVin and GMEVin
 *
 * @author Ethan Jones
 */
class HardwareDependencySelector extends React.Component{

    serverApi;
    state = {
        renderHardwareDependencies: false,
        renderCalibrationTable: false,
        chainOfParts: null,
        hardwareList: null,
        hardwareId: null,
        selectorMessage: "Please select..."
    }
    constructor(props) {
        super(props);
        this.serverApi = new api()
        this.setSelectionMessage = this.setSelectionMessage.bind(this)
    }


    async setSelectionMessage(message){
        message = await message.replace(/\\/,'').replace(/\\/,'')
        await this.setState({
            selectorMessage: message
        })
    }

    /**
     * Handler used when user selects a hardware part number
     * @param e the value of the selection
     * @returns {Promise<void>}
     */
    async handleHardwareSelection(e){

        if(e === "default"){

            await this.props.turnOffDisplay()
        }else {
            await this.props.turnOffDisplay()
            await this.props.hardwareHandler(e)
        }
    }

    /**
     * Iterates through hardware part numbers and displays them in a drop down selection menu
     * @returns {*}
     */
    renderHardwareDependencySelector(){
        return(
            <select className={"hardwareSelector"} onChange={async e=>this.handleHardwareSelection(e.target.value)}>
                <option value={"default"}>{this.state.selectorMessage}</option>
                {
                    this.props.hardwareList.map((data, index)=>(
                        <option>{data}</option>
                    ))
                }
            </select>
        )
    }

    /**
     * Main render method for Hardware Dependency Selector
     * @returns {*}
     */
    render() {

        return (
            <div>
                {this.renderHardwareDependencySelector()}
            </div>
        );
    }
}

export default HardwareDependencySelector;